import { render } from "./UserDashBoard.vue?vue&type=template&id=03abdda5&scoped=true"
import script from "./UserDashBoard.vue?vue&type=script&lang=js"
export * from "./UserDashBoard.vue?vue&type=script&lang=js"

import "./UserDashBoard.vue?vue&type=style&index=0&id=03abdda5&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03abdda5"]])

export default __exports__